import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Divider,
} from '@material-ui/core';
import React from 'react';
import { injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

function ErrorDialog({ intl, open, message, onClose }) {
  return (
    <Dialog fullWidth open={open}>
      <DialogTitle>
        <div className="col-12">
          <span className="font-weight-bolder">Oops!</span>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ minHeight: 80 }}>
        <div className="d-flex">
          <div className="col-2">
            <SVG src={toAbsoluteUrl('/media/senseworks/alert.svg')} />
          </div>
          <div className="col-10 d-flex align-items-center">
            {intl.formatMessage({ id: message })}
          </div>
        </div>
      </DialogContent>
      <Divider />
      <DialogActions>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-bordered h-25px w-50px d-flex align-items-center btn-primary justify-content-center"
        >
          {intl.formatMessage({ id: 'ACTIONS.OK' })}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default injectIntl(ErrorDialog);
